import React from 'react';
import PropTypes from 'prop-types';
import {Avatar} from "material-ui";
import gravatar from 'gravatar';
import AdminInfo from './AdminInfo/AdminInfo';
import ApplicationList from '../../application/ApplicationList/ApplicationList';
import styles from './AdminFull.css';
import style from '../../../styles/styles';

class AdminFull extends React.Component {

    render() {
        return (
            <div>
                <Avatar src={gravatar.url(this.props.admin.email)}
                        size={75}
                        style={styles.avatar}/>
                <div className="row">
                    <div style={style.col} className="col-xs-12 col-sm-6 col-md-6">
                        <AdminInfo admin={this.props.admin}/>
                    </div>
                    <div style={style.col} className="col-xs-12 col-sm-6 col-md-6">
                        <ApplicationList
                            loading={false}
                            admin={this.props.admin}
                            apps={this.props.apps}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

AdminFull.propTypes = {
    admin: PropTypes.object.isRequired,
    apps: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default AdminFull;



// WEBPACK FOOTER //
// src/components/admin/AdminFull/AdminFull.js